import { Pegasus } from 'corso-types';
import DescriptionList, { Description } from '~/components/DescriptionList';
import useFulfillmentLocations from '~/features/settings/automations/hooks/useFulfillmentLocations';
import {
  restockProviderActionLabel,
  shopifyRestockNameLabel,
} from '~/utils/enumNameMaps';

export default function EventRestockInventoryDisplay({
  params,
}: {
  params: Pegasus.EventRestockInventory['params'];
}) {
  const { data: fulfillmentLocations = [] } = useFulfillmentLocations();

  const { restockPlatform } = params;

  const configDescriptions: Description[] = [];

  configDescriptions.push({
    term: 'Restock To',
    details: restockProviderActionLabel[restockPlatform],
  });

  if (restockPlatform === Pegasus.RestockPlatform.SHOPIFY) {
    const { restockLocationIdFromPlatform, shopifyRestockName } = params;

    if (shopifyRestockName !== 'none') {
      configDescriptions.push({
        term: 'Restock Location',
        details:
          fulfillmentLocations.find(
            ({ idFromPlatform }) =>
              idFromPlatform === restockLocationIdFromPlatform,
          )?.name ?? `Location Id: ${restockLocationIdFromPlatform}`,
      });
    }

    configDescriptions.push({
      term: 'Inventory State',
      details: shopifyRestockNameLabel[shopifyRestockName].label,
    });
  }

  return (
    <div className="mt-2 flex flex-col items-start gap-4">
      <DescriptionList descriptions={configDescriptions} layoutType="list" />
    </div>
  );
}
